import { Button, Paper } from "@mui/material";

import BreadcrumbsBar from "../../component/common/BreadcrumbsBar";
import PageHeader from "../../component/common/PageHeader";
import { useAuth } from "../../context/AuthContext";
export default function Users() {
  const { user } = useAuth();
// console.log(user.username);
// console.log(user.fullName);
// console.log(user.email);
// console.log(user.role);


  return (
    
    <>
      <BreadcrumbsBar page="Users" />

      <PageHeader
        title="Users"
        subtitle="Manage application users"
        action={
          <Button variant="contained">
            Add User
          </Button>
        }
      />

      <Paper sx={{ p: 3 }}>
        User table will come here.
      </Paper>
    </>
  );
}